import { useTranslation } from "react-i18next";
import React from "react";
import { DateFormat, IDateFormatdProps, AmountFormat } from "components/common";
import { StepsItemProps } from "../StepsItem/StepsItem.types";
import { ContentWithTooltip } from '../ContentWithTooltip';


const StepsItemView: React.FC<StepsItemProps> = ({
  processing,
  customClasses,
  data,
  config
}: StepsItemProps) => {
  const TableDateFormat: React.FC<IDateFormatdProps> = ({ date, lang }: IDateFormatdProps) => {
    return <DateFormat date={date} lang={lang} type={'full'} />;
  };

  const { t } = useTranslation();

  const title = (idx: number) => {
    return config && config[idx] ? t(config[idx].replace(" ", "_").toLowerCase() + "_string") : "";
  };

  let statusClass = "";
  switch (data.status) {
    case "active": statusClass = "active"; break;
    case "rejected": statusClass = "rejected"; break;
    case "passed": statusClass = "approved"; break;
  }
  return (
    <div className={`table-steps__row ${statusClass} ${customClasses}`}>
      <div className="table-steps__line">
        <div className="table-steps__td total">
          <div className="mob-label">{title(0)}</div>
          {Number.isFinite(data.total) ? <><AmountFormat amount={data.total} decimals={data.totalDecimals ? data.totalDecimals : 2} /> {data.currency}</> : data.total}
        </div>
        <div className="table-steps__td price">
          <div className="mob-label">{title(1)}</div>
          <ContentWithTooltip tooltip={data.price}>
            {
              Number.isFinite(data.price)
                ? <AmountFormat amount={data.price} decimals={data.priceDecimals ? data.priceDecimals : 4} />
                : data.price
            }
          </ContentWithTooltip>
        </div>
        <div className="table-steps__td quantity">
          <div className="mob-label">{title(2)}</div>
          <ContentWithTooltip tooltip={data.quantity}>
            {
              Number.isFinite(data.quantity)
                ? <AmountFormat amount={data.quantity} decimals={data.quantityDecimals ? data.quantityDecimals : 2} />
                : data.quantity
            }
          </ContentWithTooltip>
        </div>
        <div className="table-steps__td currency-type">
          <div className="mob-label">{title(3)}</div>
          {data.currency_type}
        </div>
        <div className="table-steps__td type">
          <div className="mob-label">{title(4)}</div>
          {data.type}
        </div>
        <div className="table-steps__td date">
          <div className="mob-label">{title(5)}</div>
          {data.approval_date && data.approval_date !== "-" ? <TableDateFormat date={data.approval_date} lang="en" /> : data.approval_date}
        </div>

        <div className={"table-steps__td step" + (statusClass == 'active' ? ' active' : '') + (data.text && !data.step ? ' line' : '')}>
          {data.step && <div className="table-steps__step-num">{t("step_string")} {data.step}</div>}
          {data.text && <><div className="mob-label">{t("name_string")}</div><div className="table-steps__step-text">{data.text}</div></>}
        </div>
      </div>
    </div>
  );
};

export default StepsItemView;
